/** Kuraterede delmål på roadmap — kun bogstav-grupper (ingen koncept-labels). */

export interface CurriculumMilestone {
  id: string;
  label: string;
  /** Trin er gennemført når dette trin-id er i completedTrinIds. */
  trinId: string;
}

export const CURRICULUM_MILESTONES: CurriculumMilestone[] = [
  { id: 'fj', label: 'F·J', trinId: 'grundniveau-trin-1' },
  { id: 'dk', label: 'D·K', trinId: 'grundniveau-trin-2' },
  { id: 'sl', label: 'S·L', trinId: 'grundniveau-trin-3' },
  { id: 'ei', label: 'E·I', trinId: 'niveau-1-trin-1' },
  { id: 'gh', label: 'G·H', trinId: 'niveau-1-trin-2' },
  { id: 'rt', label: 'R·T', trinId: 'niveau-1-trin-3' },
  { id: 'o', label: 'Ø', trinId: 'niveau-2-trin-1' },
  { id: 'nm', label: 'N·M', trinId: 'niveau-2-trin-2' },
  { id: 'vb', label: 'V·B', trinId: 'niveau-2-trin-3' },
  { id: 'u', label: 'U', trinId: 'niveau-3-trin-1' },
  { id: 'wo', label: 'W·O', trinId: 'niveau-3-trin-2' },
  { id: 'qp', label: 'Q·P', trinId: 'niveau-3-trin-3' },
  { id: 'aa', label: 'Å', trinId: 'niveau-3-trin-4' },
  { id: 'cx', label: 'C·X', trinId: 'niveau-4-trin-1' },
  { id: 'z', label: 'Z·,', trinId: 'niveau-4-trin-2' },
  { id: 'dot', label: '.·-', trinId: 'niveau-4-trin-3' },
  { id: 'shift', label: 'A·Ø', trinId: 'niveau-5-trin-1' },
  { id: 'top', label: 'E·Å', trinId: 'niveau-5-trin-2' },
  { id: 'bot', label: 'Z·G', trinId: 'niveau-5-trin-3' },
  { id: 'cap', label: 'J·D', trinId: 'niveau-5-trin-4' },
  { id: 'colon', label: ':·;', trinId: 'niveau-5-trin-5' },
  { id: 'quest', label: '?·!', trinId: 'niveau-5-trin-6' },
  { id: 'n6-flow', label: 'Flow', trinId: 'niveau-6-trin-3' },
];
